export default function (parts: any[]) {
  return parts
    .filter((part) => typeof part === "string")
    .map((part) => part.trim())
    .filter((part) => part.length > 0)
    .join(" ");
}